import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Supports from "./pages/Supports";
import SupportDetail from "./pages/SupportDetail";
import Formulaires from "./pages/Formulaires";
import Carte from "./pages/Carte";
import Rapports from "./pages/Rapports";
import Scanner from "./pages/Scanner";
import Categories from "./pages/Categories";
import Import from "./pages/Import";

function App() {
  const [token, setToken] = useState(localStorage.getItem("token"));

  const handleLogin = (tk) => { localStorage.setItem("token", tk); setToken(tk); };
  const handleLogout = () => { localStorage.removeItem("token"); setToken(null); };

  if (!token) return (
    <>
      <Login onLogin={handleLogin} />
      <Toaster position="top-right" />
    </>
  );

  return (
    <BrowserRouter>
      <Toaster position="top-right" />
      <Layout onLogout={handleLogout}>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/supports" element={<Supports />} />
          <Route path="/supports/:id" element={<SupportDetail />} />
          <Route path="/formulaires" element={<Formulaires />} />
          <Route path="/carte" element={<Carte />} />
          <Route path="/rapports" element={<Rapports />} />
          <Route path="/scanner" element={<Scanner />} />
          <Route path="/categories" element={<Categories />} />
          <Route path="/import" element={<Import />} />
          <Route path="/support/:id" element={<SupportDetail public />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  );
}

export default App;
